import type { MenuId } from '../stores/uiStore'

/**
 * 해시 라우팅 — MenuId ↔ URL 해시 경로 매핑.
 * SPA가 S3/CloudFront 정적 호스팅 위에서도 새로고침·직접 접근에 안전하도록 해시(`#/...`) 방식을 쓴다.
 */

const MENU_TO_PATH: Record<MenuId, string> = {
  engine: '/dashboard',
  linkband: '/device-manager',
  visualizer: '/visualizer',
  datacenter: '/data-center',
  'stream-process': '/stream-process',
  cloudmanager: '/documents',
  settings: '/settings',
}

const PATH_TO_MENU: Record<string, MenuId> = Object.entries(MENU_TO_PATH).reduce(
  (acc, [menu, path]) => {
    acc[path] = menu as MenuId
    return acc
  },
  {} as Record<string, MenuId>,
)

/** MenuId → 해시 문자열 (예: '#/documents') */
export function menuToHash(menu: MenuId): string {
  return `#${MENU_TO_PATH[menu] ?? '/dashboard'}`
}

/** 해시 문자열 → MenuId (매핑 실패 시 null) */
export function hashToMenu(hash: string): MenuId | null {
  const path = hash.startsWith('#') ? hash.slice(1) : hash
  const clean = path.startsWith('/') ? path : `/${path}`
  return PATH_TO_MENU[clean] ?? null
}

/** 해시 문자열을 정규화된 해시로 변환 (미인식 경로는 대시보드로) */
export function normalizeHash(hash: string): string {
  const menu = hashToMenu(hash)
  return menu ? menuToHash(menu) : '#/dashboard'
}
